import React from 'react'
import {Box} from "grommet";

export const WelcomePage = () => {
  return <Box>
    Welcome page
  </Box>
}
